import Vue from 'vue';
import SegmentedProgressBar from './SegmentedProgressBar.vue';

export default SegmentedProgressBar;
